export enum ParentSort {
  FIRST_NAME = 'first_name',
  REGISTRATION_DATE = 'created_at',
}
